import script from "./DetailItemJit.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailItemJit.vue?vue&type=script&setup=true&lang=js"

import "./DetailItemJit.vue?vue&type=style&index=0&id=004e9b3c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-004e9b3c"]])

export default __exports__